import {IFieldErrorMessageVariant, IFieldState} from "../types";

export const getFieldStateColor = (fieldState?: IFieldState, errorMessageVariant: IFieldErrorMessageVariant = "default") => {
    switch (fieldState) {
        case "error":
            return errorMessageVariant === "alternative" ? "--colors-inputTextError" : "--colors-danger";

        case "focused":
            return "--colors-info";

        default:
            return "--colors-gray-600";
    }
};
import {IFieldErrorMessageVariant, IFieldState} from "../types";

export const getFieldStateColor = (fieldState?: IFieldState, errorMessageVariant: IFieldErrorMessageVariant = "default") => {
    switch (fieldState) {
        case "error":
            return errorMessageVariant === "alternative" ? "--colors-inputTextError" : "--colors-danger";

        case "focused":
            return "--colors-info";

        default:
            return "--colors-gray-600";
    }
};
